"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

/**
 * Hook that returns true on the first render and false on subsequent renders
 */
function useIsFirstRender() {
  var isFirst = (0, _react.useRef)(true);

  if (isFirst.current) {
    isFirst.current = false;
    return true;
  }

  return isFirst.current;
}

var _default = useIsFirstRender;
exports["default"] = _default;
//# sourceMappingURL=useIsFirstRender.js.map